module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ;  var item = widget.item; 
    ; __append("\n\n<div class=\"spl-view-page\">\n    <div class=\"table wh100\">\n        ")
    ;  if (isRoot()) { 
    ; __append("\n        <div class=\"section\">\n            <div class=\"title\">\n                JS класс\n            </div>\n            <div>\n                <div\n                    data-control-type=\"text\"\n                    data-control-target=\"item.jsclass\"\n                >\n                    ")
    ; __append(escapeFn( Util.coalesce(item.jsclass, item.layer.jsclass) ))
    ; __append("\n                </div>\n            </div>\n        </div>\n        ")
    ;  } 
    ; __append("\n        <div class=\"section\">\n            <div class=\"title\">Прозрачность</div>\n            <div>\n                <div\n                    data-control-type=\"range\"\n                    data-control-target=\"opacity\"\n                    data-control-min=\"0\"\n                    data-control-max=\"100\"\n                    data-control-step=\"1\"\n                    data-control-units=\"%\"\n                    data-control-html-value=\"100\"\n                >\n                    ")
    ; __append(escapeFn( widget.opacity ))
    ; __append("\n                </div>\n            </div>\n        </div>\n        <div class=\"section\">\n            <div class=\"title\">Минимальный зум</div>\n            <div>\n                <div\n                    data-control-type=\"range\"\n                    data-control-target=\"item.options.minZoom\"\n                    data-control-min=\"0\"\n                    data-control-max=\"30\"\n                    data-control-step=\"1\"\n                    data-control-html-value=\"0\"\n                >\n                    ")
    ; __append(escapeFn( Util.coalesce(_.get(item, "options.minZoom"), _.get(item, "layer.options.minZoom"), 0) ))
    ; __append("\n                </div>\n            </div>\n        </div>\n        <div class=\"section\">\n            <div class=\"title\">Максимальный зум</div>\n            <div>\n                <div\n                    data-control-type=\"range\"\n                    data-control-target=\"item.options.maxZoom\"\n                    data-control-min=\"0\"\n                    data-control-max=\"30\"\n                    data-control-step=\"1\"\n                    data-control-html-value=\"30\"\n                >\n                    ")
    ; __append(escapeFn( Util.coalesce(_.get(item, "options.maxZoom"), _.get(item, "layer.options.maxZoom"), 30) ))
    ; __append("\n                </div>\n            </div>\n        </div>\n        <div class=\"section\">\n            <div class=\"title\">Зум по умолчанию</div>\n            <div>\n                <div\n                    data-control-type=\"range\"\n                    data-control-target=\"item.options.zoom\"\n                    data-control-min=\"0\"\n                    data-control-max=\"30\"\n                    data-control-step=\"1\"\n                >\n                    ")
    ; __append(escapeFn( Util.coalesce(_.get(item, "options.zoom"), _.get(item, "layer.options.zoom")) ))
    ; __append("\n                </div>\n            </div>\n        </div>\n        <div class=\"section\">\n            <div class=\"title\">Центр карты по умолчанию <sub>Долгота/Широта через пробел</sub></div>\n            <div>\n                <div\n                    data-control-type=\"point\"\n                    data-control-target=\"item.options.center\"\n                >\n                    ")
    ; 
                    var center = Util.coalesce(_.get(item, "options.center"), _.get(item, "layer.options.center"));
                    
    ; __append("\n                    ")
    ; __append(escapeFn( center ? center.coordinates.join(' ') : '' ))
    ; __append("\n                </div>\n            </div>\n        </div>\n\n    </div>\n\n    <!-- styles -->\n    ")
    ;  if (!_.isEmpty(widget.styleHash)) { 
    ; __append("\n    <hr/>\n    <div name=\"styles\" class=\"class-styles\">\n        <h3>Стили</h3>\n        <div>\n            ")
    ; 
                var hasSLD = item.id && item.geomtype && widget.layer && widget.layer.getType() === GIS.LayerType.Vector;
            
    ; __append("\n            <button name=\"import-style\" class=\"")
    ; __append(escapeFn( hasSLD ? "" : "hidden" ))
    ; __append("\" on-click=\"onImportStyleClick\">Импорт SLD</button>\n            <button name=\"export-style\" class=\"")
    ; __append(escapeFn( hasSLD ? "" : "hidden" ))
    ; __append("\" on-click=\"onExportStyleClick\">Экспорт SLD</button>\n        </div>\n        <br/>\n        <div id=\"tabs\">\n            <ul>\n                ")
    ;  _.forEach(widget.styleHash, function(style) { 
    ; __append("\n                <li><a href=\"#tab-")
    ; __append(escapeFn( style.name ))
    ; __append("\">")
    ; __append(escapeFn( style.title ))
    ; __append("</a></li>\n                ")
    ;  }) 
    ; __append("\n            </ul>\n            <!-- styles per name -->\n            ")
    ;  _.forEach(widget.styleHash, function(style) { 
    ; __append("\n            <div id=\"tab-")
    ; __append(escapeFn( style.name ))
    ; __append("\">\n                ")
    ;  _.forEach(style.styles, function(style) { 
    ; __append("\n                <div class=\"table w100\">\n                    ")
    ;  _.forEach(style, function(control) { 
    ; __append("\n                    ")
    ; 
                        var attributes = _.reduce(_.omit(control, ["value", "showValue"]), function (result, value, key) {
                            result["data-control-" + key] = value;
                            return result;
                        }, {});
                    
    ; __append("\n                    <div class=\"section\">\n                        <div class=\"title\">")
    ; __append(escapeFn( control.title ))
    ; __append("</div>\n                        <div>\n                            ")
    ;  if (control.type === "colorpicker") { 
    ; __append("\n                            <div ")
    ; __append( Html.attributes(attributes) )
    ; __append(">\n                                <span name=\"color\" class=\"color\" style=\"background: ")
    ; __append(escapeFn( control["html-value"] || "none" ))
    ; __append("\"></span>\n                                <span name=\"value\">")
    ; __append(escapeFn( control["html-value"] ))
    ; __append("</span>\n                            </div>\n                            ")
    ; 
                                var inputAttributes = _.assign({}, attributes, {
                                    'data-control-type': 'text',
                                    'data-control-html-placeholder': 'Введите цвет',
                                    'data-control-update-view': false
                                });
                            
    ; __append("\n                            <div ")
    ; __append( Html.attributes(inputAttributes) )
    ; __append("></div>\n                            ")
    ;  } else { 
    ; __append("\n                            <div ")
    ; __append( Html.attributes(attributes) )
    ; __append(">\n                                ")
    ; __append(escapeFn( control["html-value"] ))
    ; __append("\n                            </div>\n                            ")
    ;  } 
    ; __append("\n                        </div>\n                    </div>\n                    ")
    ;  }) 
    ; __append("\n                </div>\n                ")
    ;  }) 
    ; __append("\n            </div>\n            ")
    ;  }) 
    ; __append("\n            <!-- // styles per name -->\n        </div>\n    </div>\n    ")
    ;  } 
    ; __append("\n</div>\n")
  }
  return __output.join("");

}